import ReactGA from 'react-ga4';

import ActionKeysGA from 'constants/ga/ActionKeysGA';
import CategoryKeysGA from 'constants/ga/CategoryKeysGA';

const initGA = (): void => {
  const cookieFlags = process.env.REACT_APP_GA_COOKIE_FLAGS ?? undefined;
  const trackingId = process.env.REACT_APP_GA_MEASUREMENT_ID ?? '';

  ReactGA.initialize(trackingId, {
    gaOptions: {
      cookieFlags,
    },
  });
};

/**
 * Tracks page views
 *
 * @param page Visited page
 * @param options Optional object of options
 */
const pageViewGA = (page: string): void => {
  ReactGA.set({ page });
  ReactGA.send({ hitType: 'pageview', page });
};

/**
 * Tracks modal views
 *
 * @param modal Visited modal
 */
const modalViewGA = (modal: string): void => {
  ReactGA.set({ page: modal });
  sendEventGA(modal, ActionKeysGA.ModalView);
};

/**
 * Tracks thrown exceptions
 *
 * @param description Description of thrown exception
 */
const sendExceptionGA = (description: string): void => {
  sendEventGA(description, ActionKeysGA.SendException);
};

/**
 * userId must not be as PII (personally identifiable information)
 * emails, tax numbers etc are not allowed. This is simply for the sake of
 * getting multiple logins from same credentials counted as one in GA
 *
 * @param userId The logged-in user's ID
 */
const setUserIdGA = (userId: string): void => {
  ReactGA.set({ userId });
};

/**
 * Tracks application events
 *
 * @param category Category of application event
 * @param action Action of application event
 * @param label Optional label for event data
 * @param value Optional value
 * @param nonInteraction Specifies if event is non-interactive
 */
const sendEventGA = (
  category: typeof CategoryKeysGA[keyof typeof CategoryKeysGA] | string,
  action: typeof ActionKeysGA[keyof typeof ActionKeysGA],
  label?: string,
  value?: number,
  nonInteraction?: boolean
): void => {
  ReactGA.event({
    category, // Required
    action, // Required
    label: label ?? '',
    value: value ?? 0,
    nonInteraction: nonInteraction ?? false,
  });
};

export {
  initGA,
  pageViewGA,
  modalViewGA,
  sendEventGA,
  setUserIdGA,
  sendExceptionGA,
};
